import { useNextRouterHandler, decodeParam } from "../../hooks/useNextRouterHandler";
import algoliasearch from "algoliasearch/lite";
import { useState, useContext, useEffect } from "react";
import Head from "next/head";
import {
  InstantSearch,
  Hits,
  Configure,
  InstantSearchSSRProvider,
  useInstantSearch,
  useClearRefinements,
  useSearchBox,
  usePagination,
} from "react-instantsearch-hooks-web";
import { getServerState } from "react-instantsearch-hooks-server";
import { renderToString } from "react-dom/server";
import { useSpecials } from "../../context/specials";
import useMediaQuery from "../../hooks/useMediaQuery";

import styles from "./shop.module.scss";
import productCardStyles from "../../components/product/ProductCard.module.scss";


import MessageXmark from "../../components/icons/message-xmark.svg";
import ArrowRotateLeft from "../../components/icons/arrow-rotate-left.svg";

import ProductCard from "../../components/product/ProductCard";
import { NextSeo } from "next-seo";
import StoreContext from "../../context/store";
import CurrentRefinements from "../../components/shop/CurrentRefinements";

import Pagination from "../../components/shop/Pagination";
import Header from "../../components/shop/Header";
import ShopNav from "../../components/shop/ShopNav";
// import Carousels from "../../components/shop/Carousels";

import dynamic from "next/dynamic";
const Carousels = dynamic(() => import('../../components/shop/Carousels'), {
  ssr: false,
});

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_KEY
);

const indexName = "menu-products-by-rating-production";

export async function getServerSideProps({ req }) {
  const protocol = req.headers.referer?.split("://")[0] || "https";
  const url = `${protocol}://${req.headers.host}${req.url}`;
  const initialStore = req.cookies.JANE_STORE || 4398;
  const serverState = await getServerState(
    <Shop url={url} initialStore={initialStore} />,
    { renderToString }
  );

  return {
    props: {
      serverState,
      url,
      initialStore,
    },
  };
}

export default function Shop({ serverState, url, initialStore }) {
  console.log(serverState);
  const { initialUiState, NextRouterHandler } = useNextRouterHandler({
    url,
    routeToState(params) {

      return {
        [indexName]: {
          query: params.q ? params.q : null,
          refinementList: {
            root_types: decodeParam(params.category, "root_types"),
            brand: decodeParam(params.brand, "brand"),
            category: decodeParam(params.strain, "category"),
            feelings: decodeParam(params.effect, "feelings"),
            available_weights: decodeParam(params.weight, "available_weights"),
            applicable_special_ids: decodeParam(params.special, "applicable_special_ids"),
          },
          range: {
            bucket_price: params.price ? params.price : null,
            percent_thc: params.thc ? params.thc : null,
            percent_cbd: params.cbd ? params.cbd : null,
          },
          page: params.page ? params.page : null,
          sortBy: params.sortBy ? params.sortBy : null,
        },
      };
    },
    stateToRoute(uiState) {
      const indexUiState = uiState[indexName];

      const serializeParam = (param, key) =>
        param?.length
          ? param.map((item) =>
              key === "brand" ? item : item.toLowerCase().replace(/ /g, "+")
            ).join(",")
          : null;

          return {
            category: serializeParam(indexUiState.refinementList?.root_types),
            brand: serializeParam(indexUiState.refinementList?.brand, "brand"),
            strain: serializeParam(indexUiState.refinementList?.category),
            effect: serializeParam(indexUiState.refinementList?.feelings),
            weight: serializeParam(indexUiState.refinementList?.available_weights),
            special: serializeParam(indexUiState.refinementList?.applicable_special_ids),
            price: indexUiState.range?.bucket_price || null,
            thc: indexUiState.range?.percent_thc || null,
            cbd: indexUiState.range?.percent_cbd || null,
            q: indexUiState.query || null,
            page: indexUiState.page || null,
            sortBy: indexUiState.sortBy || null,

          };
        
        },
  });

  const { store } = useContext(StoreContext);
  const [list, setList] = useState(false);
  const { specials, loading, error, fetchAllSpecials } = useSpecials();
  const isBreakPoint = useMediaQuery(1200);

  // fetch product specials
  useEffect(() => {
    if (store) {
      fetchAllSpecials(store);
    }
  }, [store, fetchAllSpecials]);



  return (
    <>
      <NextSeo
        title="Shop All Cannabis Products | Purple Lotus"
        description="1 Cannabis Dispensary in the Bay Area"
        canonical="https://plpcsanjose.com/shop"
        openGraph={{
          url: 'https://plpcsanjose.com/shop',
          title: 'Shop All Cannabis Products | Purple Lotus',
          description: '1 Cannabis Dispensary in the Bay Area',
          images: [
            {
              url: 'https://plpcsanjose.com/images/purple-lotus-store-counters.jpg',
              width: 800,
              height: 600,
              alt: 'Purple Lotus Cannabis Dispensary',
              type: 'image/jpeg',
            },
          ],
          siteName: 'Purple Lotus',
        }}
      />
      <Head>
        <title>Shop All Cannabis Products | Purple Lotus</title>
        <meta
          property="og:title"
          content="#1 Cannabis Dispensary in the Bay Area | Purple Lotus | Purple Lotus"
          key="title"
        />
        <meta
          name="description"
          content="Purple Lotus Patient Center is the #1 cannabis dispensary in the Bay Area. Located in San Jose CA. Browse our cannabis deals & specials, pre-order online!"
        />
        <meta
          property="og:image"
          content="https://cdn.sanity.io/images/10gj8xqe/production/564fc5a18d4d3132dd586e3b1a7d58fcc7122fde-1368x912.jpg"
        />
      </Head>

      <main>
        <InstantSearchSSRProvider {...serverState}>
          <InstantSearch
            searchClient={searchClient}
            indexName={indexName}
            initialUiState={initialUiState}
          >
            <NextRouterHandler />
            <Configure
              filters={`store_id:${store || initialStore}`}
            // attributesToRetrieve={[
            //     "objectID",
            //     "product_id",
            //     "name",
            //     "brand",
            //     "image_urls",
            //   ]}
            />


            <div className={styles.header}>
              <Header category="all" url={url} />
              <VirtualSearchBox />
              <VirtualPagination />
            </div>

            <ShopNav url={url} list={list} setList={setList} />

            {/* <Carousels specials={specials} /> */}

            <div className={!isBreakPoint ? "container" : undefined}>
              <div className={styles.stats}>
                <Stats />
                <CurrentRefinements productSpecials={specials} />
              </div>


              <div className={`${list ? productCardStyles.list : 'shop-product-grid'}`}>
                <NoResultsBoundary fallback={<NoResults />}>
                  <Hits hitComponent={ProductCard} />
                  <Pagination />
                </NoResultsBoundary>
              </div>

            </div>

          </InstantSearch>
        </InstantSearchSSRProvider>
      </main>
    </>
  );
}


function CustomClearRefinements(props) {
  const { canRefine, refine } = useClearRefinements(props);

  if (canRefine) {
    return (
      <button className="button" data-type="basic" onClick={() => refine()}>
        Reset Filters {" "}
        <ArrowRotateLeft />
      </button>
    );
  }
}

function NoResultsBoundary({ children, fallback }) {
  const { results, status } = useInstantSearch();

  // The `__isArtificial` flag makes sure not to display the No Results message
  // when no hits have been returned yet.
  if (!results.__isArtificial && results.nbHits === 0) {
    return (
      <>
        {fallback}
        <div hidden>{children}</div>
      </>
    );
  }

  return children;
}

function NoResults() {
  const { indexUiState } = useInstantSearch();

  return (
    <div className={styles.no_results}>
      <MessageXmark style={{ fontSize: "3rem" }} />
      <span>
        {indexUiState.query ? (
          <span>
            No products match your search: <q>{indexUiState.query}</q>
          </span>
        ) : (
          "No products match your search criteria or are available at this location."
        )}
      </span>
      <CustomClearRefinements
        text="Clear all filters"
        includedAttributes={[
          "query",
          "category",
          "brand",
          "root_types",
          "feelings",
          "available_weights",
          "applicable_special_ids",
        ]}
      />
    </div>
  );
}

function Stats() {
  const { scopedResults } = useInstantSearch();

  const mainIndexResults = scopedResults.find(
    (result) => result.indexId === "menu-products-by-rating-production"
  );

  if (!mainIndexResults || !mainIndexResults.results) return null;

  const { results } = mainIndexResults;

  return (
    <span className={styles.productCount}>
      {results.nbHits === 0
        ? "No Products"
        : `${results.nbHits} ${results.nbHits > 1 ? "Products" : "Product"}`}
    </span>
  );
}


function VirtualSearchBox() {
  // need this for the search box/query links to work
  useSearchBox();
  return null;
}

function VirtualPagination() {
  // need this for the search box/query links to work
  usePagination();
  return null;
}